import { h } from "omi";

import { IconProps } from "@/wc/components";

export function SwitchVerticalIcon({ width, height }: IconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} viewBox="0 0 18 16">
      <path
        d="M4.83333 1.33398V14.6673m0 0L1.5 11.334m3.33333 3.3333 3.33334-3.3333m5.00003 3.3333V1.33398m0 0L9.83333 4.66732m3.33337-3.33334L16.5 4.66732"
        stroke="currentColor"
        stroke-width="1.66667"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
